import React, { useEffect, Suspense, lazy } from 'react';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { initMetaPixel } from './utils/metaPixel';
const PainPoints = lazy(() => import('./components/PainPoints').then(m => ({
  default: m.PainPoints
})));
const WhyExists = lazy(() => import('./components/WhyExists').then(m => ({
  default: m.WhyExists
})));
const BeforeAfter = lazy(() => import('./components/BeforeAfter').then(m => ({
  default: m.BeforeAfter
})));
const Authority = lazy(() => import('./components/Authority').then(m => ({
  default: m.Authority
})));
const ProductOverview = lazy(() => import('./components/ProductOverview').then(m => ({
  default: m.ProductOverview
})));
const VisualDesire = lazy(() => import('./components/VisualDesire').then(m => ({
  default: m.VisualDesire
})));
const ContentOverview = lazy(() => import('./components/ContentOverview').then(m => ({
  default: m.ContentOverview
})));
const Bonuses = lazy(() => import('./components/Bonuses').then(m => ({
  default: m.Bonuses
})));
const WhatYouGet = lazy(() => import('./components/WhatYouGet').then(m => ({
  default: m.WhatYouGet
})));
const ValueFraming = lazy(() => import('./components/ValueFraming').then(m => ({
  default: m.ValueFraming
})));
const Pricing = lazy(() => import('./components/Pricing').then(m => ({
  default: m.Pricing
})));
const SocialProof = lazy(() => import('./components/SocialProof').then(m => ({
  default: m.SocialProof
})));
const Guarantee = lazy(() => import('./components/Guarantee').then(m => ({
  default: m.Guarantee
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const FinalCTA = lazy(() => import('./components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
export function App() {
  useEffect(() => {
    // Aggressively defer Meta Pixel - only after 5 seconds or user interaction
    if (typeof window !== 'undefined') {
      let pixelLoaded = false;
      const loadPixel = () => {
        if (!pixelLoaded) {
          pixelLoaded = true;
          // Use requestIdleCallback for even lower priority
          if ('requestIdleCallback' in window) {
            requestIdleCallback(() => initMetaPixel(), {
              timeout: 2000
            });
          } else {
            setTimeout(initMetaPixel, 100);
          }
        }
      };
      // Load on user interaction or after 5 seconds
      const events = ['scroll', 'click', 'touchstart'];
      events.forEach(event => {
        window.addEventListener(event, loadPixel, {
          once: true,
          passive: true
        });
      });
      const timeout = setTimeout(loadPixel, 5000);
      return () => {
        events.forEach(event => window.removeEventListener(event, loadPixel));
        clearTimeout(timeout);
      };
    }
  }, []);
  return <div className="min-h-screen bg-brand-bg text-brand-text font-body selection:bg-brand-primary/20 selection:text-brand-primary" data-id="element-0" data-mp="2svagp5fa2m2f">
      <Hero data-id="element-1" data-mp="18by986nrad12" />
      <StatsBar data-id="element-2" data-mp="1d47wtg1ef106" />

      <Suspense fallback={null} data-id="element-3" data-mp="1d4recvn4zndo">
        <PainPoints data-id="element-4" data-mp="1d62hct8rcr3q" />
        <WhyExists data-id="element-5" data-mp="1d6aw6qofy6hk" />
        <BeforeAfter data-id="element-6" data-mp="yfv916cgsogr" />
        <Authority data-id="element-7" data-mp="ygd4w1v7t0o5" />
        <ProductOverview data-id="element-8" data-mp="ygworo4fdz4t" />
        <VisualDesire data-id="element-9" data-mp="ydikgac7bfuq" />
        <ContentOverview data-id="element-10" data-mp="13eexpeig0ect" />
        <Bonuses data-id="element-11" data-mp="13dwpdjiia9oj" />
        <WhatYouGet data-id="element-12" data-mp="13fg6fcbzkord" />
        <ValueFraming data-id="element-13" data-mp="13clphus6lm2p" />
        <Pricing data-id="element-14" data-mp="1r4971m3jzksb" />
        <SocialProof data-id="element-15" data-mp="1r3r6id9uykel" />
        <Guarantee data-id="element-16" data-mp="1r5kbzp8qiyl0" />
        <FAQ data-id="element-17" data-mp="1r52600w9t5zw" />
        <FinalCTA data-id="element-18" data-mp="1r26ccorgh3h9" />
        <Footer data-id="element-19" data-mp="1w33pgmxlz7bw" />
      </Suspense>
    </div>;
}